import i18n, { type BackendModule } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en, NAMESPACE, type Translations } from '@/assets/locales/en.ts';

const resources = {
  en,
} as const;

// Only English ships in the main bundle; other languages are fetched the first time they are used
const LAZY_LOCALES: Record<string, () => Promise<Translations>> = {
  pl: () => import('@/assets/locales/pl.ts').then(({ pl }) => pl),
};

const lazyLocalesBackend: BackendModule = {
  init: () => undefined,
  read: (language, namespace, callback) => {
    const loadLocale = LAZY_LOCALES[language];
    if (!loadLocale) {
      callback(null, null);
      return;
    }
    loadLocale()
      .then(translations => callback(null, translations[namespace]))
      .catch((error: unknown) => callback(error instanceof Error ? error : String(error), null));
  },
  type: 'backend',
};

void i18n
  .use(lazyLocalesBackend)
  .use(initReactI18next)
  .init<never>({
    defaultNS: NAMESPACE,
    detection: {
      caches: ['localStorage', 'cookie'],
      order: ['localStorage', 'cookie', 'navigator'],
    },
    fallbackLng: 'en',
    // English is bundled, so initialization stays synchronous like it was before the lazy backend
    initAsync: false,
    interpolation: {
      escapeValue: false,
    },
    lng: 'en',
    ns: [NAMESPACE],
    partialBundledLanguages: true,
    resources,
  });
